import { Helper } from "../../helpers/helper";
import { DataOption, DropdownDataOption, InputDropdownReplacementProperties } from "../../models/html.models";

export class DropdownsUtility {
    public static updateDropdownOptions<T = any>(selector: any, parentOptionValue: T, optionSelectionCriteria: (value: T, option: DataOption) => boolean) {
        let jSelect = jQuery(selector);

        // get all the available options from the data attribute, if not available, populate it from the existing list
        let dataOptions: DataOption[] = jSelect.data("options");
        if (dataOptions == null || dataOptions.length == 0) {
            dataOptions = this.getDropdownOptions(selector);
        }
        // ensure you do not modify the original object, but keep the unserializable properties
        dataOptions = JSON.parse(JSON.stringify(dataOptions))

        // clear all the current options in the select and populate with only the valid options for the selectedOption
        // store the currently selected value so that it can be set again once the select has been re-populated
        let currentlySelectedValue = jSelect.val();
        jSelect.empty();
        jQuery.each(dataOptions, function (i) {
            let option = dataOptions[i];
            option.isSelected = option.value == currentlySelectedValue;

            if (optionSelectionCriteria(parentOptionValue, option)) {
                jSelect.append(jQuery("<option>").text(option.text).val(option.value));

                if (option.isSelected) {
                    jSelect.val(currentlySelectedValue);
                }
            }
        });

        // check whether any options are available, it may not have initially populated for this type
        if (dataOptions.length > 0) {
            jSelect.trigger("change");
        }
    }

    public static getDropdownOptions(selector: any, saveData: boolean = true): DataOption[] {
        let jSelect = jQuery(selector);
        let options: DataOption[] = [];
        jSelect.find('option').each(function () {
            let jOption = jQuery(this);
            options.push({ value: jOption.val(), text: jOption.text() });
        });

        // update data options attribute
        if (saveData) {
            jSelect.data("options", options);
        }

        return options;
    }

    public static selectOnlyOption(dropdownSelector: any) {
        let jDropdown = jQuery(dropdownSelector);

        let allValidOptions = [];
        let jOptions = jDropdown.find("option");
        jOptions.each(function () {
            let jOption = jQuery(this);

            let value = jOption.attr("value");
            if (value.length > 0) {
                allValidOptions.push(value);
            }
        });

        if (allValidOptions.length == 1) {
            jDropdown.val(allValidOptions[0]);
            jDropdown.trigger("change");
        }
    }

    public static replaceInputWithDropdown(properties: InputDropdownReplacementProperties) {
        const OTHER_OPTION_VALUE = "_OTHER";
        let propertiesWithDefaults: InputDropdownReplacementProperties = Object.assign(new InputDropdownReplacementProperties(), properties);
        let { inputSelector, dropdownId, isMultiSelect, data: dropdownOptionsData, enableOtherOption } = propertiesWithDefaults;

        // add dropdown and hide input
        this.resetInputFromDropdown(inputSelector);
        let jInput = jQuery(inputSelector);
        let jDropdown = jQuery("<select id='" + dropdownId + "'></select>");
        jDropdown.prop("multiple", isMultiSelect);
        jInput.data("dropdown", dropdownId);

        // data population
        let isValidCustomValue = (value: string, data: DropdownDataOption[]) => !Helper.isStringNullOrEmpty(value) && this.findInputValueInList(value, data) == null;
        if (!isMultiSelect) {
            let emptyOption: DropdownDataOption = { value: "", description: "" };
            dropdownOptionsData = [emptyOption].concat(dropdownOptionsData);

            // add the non-empty custom value
            let value = jInput.val().toString();
            if (isValidCustomValue(value, dropdownOptionsData)) {
                if (!enableOtherOption) {
                    dropdownOptionsData.push({ value: value, description: value });
                }
            }
        } else {
            // add non-empty custom values
            let valueList = this.getInputValueAsList(jInput);
            valueList.filter(value => isValidCustomValue(value, dropdownOptionsData)).forEach(item => {
                // multi select option and the other option are not supported together
                dropdownOptionsData.push({ value: item, description: item });
            });
        }

        // add the other option if enabled and not a multi select dropdown
        if (enableOtherOption && !isMultiSelect) {
            dropdownOptionsData.push({ value: OTHER_OPTION_VALUE, description: "Other" });
        }
        dropdownOptionsData.forEach(function (item) {
            jDropdown.append("<option value='" + item.value + "'>" + item.description + "</option>");
        });

        // set current hidden input value to dropdown
        if (!isMultiSelect) {
            let value = jInput.val().toString();
            let isCustomValue = isValidCustomValue(value, dropdownOptionsData);

            if (!enableOtherOption || (enableOtherOption && !isCustomValue)) {
                jDropdown.val(value);
            } else {
                // set to other option
                jDropdown.val(OTHER_OPTION_VALUE);
            }
        } else {
            let value = this.getInputValueAsList(jInput);
            jDropdown.val(value);
        }

        // update hidden input with value if any
        // if the selected value is the other option, clear the input value for manual input if not already custom
        let updateInput = function () {
            let selectedValues = jDropdown.val();
            let currentInputValue = jInput.val().toString();
            if (!isMultiSelect) {
                let isOtherOptionSelected = selectedValues == OTHER_OPTION_VALUE;
                if (enableOtherOption && isOtherOptionSelected) {
                    jInput.show();
                    if (!isValidCustomValue(currentInputValue, dropdownOptionsData)) {
                        // clear the entry that was previously here
                        jInput.val("");
                    }
                } else {
                    jInput.hide();
                    jInput.val(selectedValues);
                }

                jInput.trigger("change");
            } else {
                jInput.hide();
                jInput.val(selectedValues).trigger("change");
            }
        };
        jDropdown.on("change", function () {
            updateInput();
        });
        updateInput();

        jDropdown.insertBefore(jInput);
    }

    public static resetInputFromDropdown(inputSelector: any) {
        // ensure if a dropdown associated with the input already exists, it is removed
        let jInput = jQuery(inputSelector);
        let inputDropdownId = jInput.data("dropdown");
        if (!Helper.isStringNullOrEmpty(inputDropdownId)) {
            jQuery("#" + inputDropdownId).remove();
        }

        jInput.show();
    }

    private static getInputValueAsList(jInput: JQuery<HTMLInputElement>): string[] {
        return jInput.val().toString().split(",");
    }

    private static findInputValueInList(inputValue: any, dataItems: DropdownDataOption[]): DropdownDataOption {
        return dataItems.find(dataItem => dataItem.value == inputValue);
    }
}